class RegionConfigModel {
  constructor (config) {
    this.tax = config.tax
    this.dw_store = config.dw_store
    this.currency = config.currency
    this.currencySymbol = config.currency_symbol
    this.decimals = config.decimals
    this.separator = config.separator
  }
}

class DefaultSelloutRangesOptionModel {
  constructor ({ component, id, fact_table }) {
    this.component = component
    this.id = id
    this.factTable = fact_table
  }
}

export default {
  isLoggedIn: state => {
    return !!localStorage.getItem('accessToken')
  },
  isConfigLoaded: (state) => {
    return state.desktopParameterConfig !== null
  },
  defaultMetric: state => {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig.mainMetric) {
      return 'PESOS'
    }
    return state.desktopParameterConfig.mainMetric.includes('quantity_sold') ? 'UNITS' : 'PESOS'
  },
  dataDimensions: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig.dimensions : []
  },
  dataPivotDimensions: (state, getters) => {
    const dimensions = getters.dataDimensions
    return dimensions ? dimensions.filter(x => x.pivot === true) : []
  },
  movableDates: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig.movableDate : []
  },
  dataMetrics: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig.metrics : []
  },
  thisYearWeekly: (state, getters) => {
    const movableDates = getters.movableDates
    if (!movableDates) return null
    const thisYear = movableDates.find(x => x.id === 'this_year_weekly')
    return thisYear ? thisYear.dateRange1 : null
  },
  lastYearWeekly: (state, getters) => {
    const movableDates = getters.movableDates
    if (!movableDates) return null
    const lastYear = movableDates.find(x => x.id === 'last_year_weekly')
    return lastYear ? lastYear.dateRange1 : null
  },
  lastLastYearWeekly: (state, getters) => {
    const movableDates = getters.movableDates
    if (!movableDates) return null
    const lastLastYear = movableDates.find(x => x.id === 'last_last_year_weekly')
    return lastLastYear ? lastLastYear.dateRange1 : null
  },
  weeklyCalendar: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig.weeklyCalendar : []
  },
  dimensionFilter: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['dimensionFilter'] : null
  },
  clientBusinessParameters: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['clientBusinessParameters'] : {}
  },
  productCategoryFilters: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['productCategoryFilters'] : []
  },
  storeFilters: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['storeFilters'] : []
  },
  feedCategories: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['feedCategories'] : []
  },
  accumulatedSalesDateOptions: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['accumulatedSalesDate'] : []
  },
  userInfo: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['userInfo'] : null
  },
  regionConfig: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['regionConfig'] : null
  },
  regionConfigModel: state => {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig['regionConfig']) {
      return null
    }
    return new RegionConfigModel(state.desktopParameterConfig['regionConfig'].config)
  },
  contractModules: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['contractModules'] : []
  },
  accumulatedSalesDateOptionByFactName: (state, getters) => factName => {
    const options = getters.accumulatedSalesDateOptions
    if (!options) return null
    return options.find(accumulatedSalesDateOption => accumulatedSalesDateOption.fact_name === factName)
  },
  userModules: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['userModules'] : []
  },
  userDefaultInitView: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['userDefaultInitView'] : 'Dashboard'
  },
  isAdmin: state => {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig['userModules']) {
      return false
    }
    const modules = state.desktopParameterConfig['userModules']
    const adminObject = modules.filter(x => x.id === 9)[0]
    return adminObject ? adminObject.is_active : false
  },
  defaultSelloutFact: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig['defaultSelloutFact'] : null
  },
  dynamicDates: state => {
    return state.desktopParameterConfig ? state.desktopParameterConfig.dynamicRanges : []
  },
  defaultSelloutRangesOption: state => {
    if (!state.desktopParameterConfig || !state.desktopParameterConfig.defaultSelloutRangesOption) {
      return null
    }
    return new DefaultSelloutRangesOptionModel(state.desktopParameterConfig.defaultSelloutRangesOption)
  },
  rootUsers: state => {
    return state.desktopParameterConfig['rootUsers'] || []
  },
  users: state => {
    return state.desktopParameterConfig['users'] || []
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js